"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleStat = void 0;
var _react = _interopRequireDefault(require("react"));
var _StatSummary = require("./StatSummary.styles");
var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _Tooltip = require("../Tooltip");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _IconButton = require("../button/IconButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var SingleStat = function SingleStat(_ref) {
  var testId = _ref.testId,
    statHeader = _ref.statHeader,
    value = _ref.value,
    style = _ref.style,
    helpMessage = _ref.helpMessage,
    align = _ref.align,
    icon = _ref.icon,
    onIconClick = _ref.onIconClick,
    iconStyle = _ref.iconStyle;
  var classes = (0, _StatSummary.useStyles)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": testId,
    className: (0, _clsx2["default"])(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes.singleTitle, true), classes.alignLeft, align === 'left'), classes.alignRight, align === 'right'), classes.alignCenter, align === 'center'))
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.key
  }, statHeader || '-', helpMessage ? /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
    title: helpMessage,
    arrow: true,
    placement: "bottom"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    size: "sm",
    icon: _proLightSvgIcons.faInfoCircle,
    style: {
      marginLeft: '8px'
    }
  }))) : null), /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.value,
    style: style
  }, value || '-', icon && /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    onClick: function onClick() {
      if (onIconClick) {
        onIconClick();
      }
    },
    icon: icon,
    style: _objectSpread({
      padding: '6px'
    }, iconStyle),
    size: "small"
  })));
};
exports.SingleStat = SingleStat;